import { getOptionValue, namedToOptionDeleted } from 'services/helpers';

import {
  checkDeleted,
  nameDescriptor,
  setDelayAmount,
} from 'pages/AutomationEngine/helpers';

import { AUTOMATION_STEPS } from 'pages/AutomationEngine/steps';

const forApi = (orgDetails) => {
  const { activity, delayAmount, type, ...details } = orgDetails;

  return {
    stepGoal: {
      ...details,
      delayAmount: setDelayAmount(delayAmount),
      triggers: [
        {
          type: AUTOMATION_STEPS.activity_logged.type,
          triggerActivityLogged: {
            activityTypeId: getOptionValue(activity),
          },
        },
      ],
    },
  };
};

const forFlow = (firstTrigger, addErrorMessage, messageDictionary) => {
  const { activityType } = firstTrigger.triggerActivityLogged;

  checkDeleted(
    messageDictionary,
    addErrorMessage,
    activityType,
    nameDescriptor
  );

  const activity = namedToOptionDeleted(activityType);
  const type = AUTOMATION_STEPS.activity_logged_goal.type;

  return {
    activity,
    type,
  };
};

export const activityLoggedGoalDTO = {
  forApi,
  forFlow,
};
